import { MdClear } from "react-icons/md";
import CustomInputField from "./CustomInputField";
import { DateTime } from "luxon";

type Props = {
  label?: string;
  onDateSelected?: (val?: DateTime) => void;
  value?: DateTime;
  min?: DateTime;
  max?: DateTime;
  disabled?: boolean;
  isClearable?: boolean;
};

function formatDate(date?: DateTime): string | undefined {
  if (!date) return undefined;
  return date.toFormat("yyyy-MM-dd");
}
function CustomDateField(props: Props) {
  return (
    <CustomInputField
      disabled={props.disabled}
      type={"date"}
      trailingIcon={
        props.isClearable && props.value ? (
          <button
            onClick={() => {
              if (props.onDateSelected) props.onDateSelected(undefined);
            }}
          >
            <MdClear />
          </button>
        ) : undefined
      }
      label={props.label}
      min={formatDate(props.min ?? DateTime.now())}
      max={formatDate(props.max)}
      value={formatDate(props.value)}
      onChange={(e) => {
        if (props.onDateSelected) {
          try {
            let _date = DateTime.fromFormat(e.target.value, "yyyy-MM-dd");

            if (props.value) {
              _date = _date.set({
                hour: props.value.hour,
                minute: props.value.minute,
                second: props.value.second,
              });
            }
            props.onDateSelected(_date);
          } catch (e) {
            props.onDateSelected(undefined);
          }
        }
      }}
    />
  );
}

export default CustomDateField;
